import { useCheckout, usePaymentMethod, useOfflinePaymentMethod } from 'lib/modules/checkout'
import { Toast } from 'lib/ui'

export const Free = () => {
  const { placeOrder } = useCheckout()

  const { setFreePaymentMethod } = useOfflinePaymentMethod()

  usePaymentMethod(() => {
    setFreePaymentMethod().then(() => {
      placeOrder()
    }).catch(() => {
      Toast.toastFailure({ messageId: 'app.whoops' })
    })
  })

  return null
}
